import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import EventEmitter from './events';
import * as dom from './dom';
import * as types from './type';
import * as utils from './index';

var Component = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Component, _EventEmitter);

  var _super = _createSuper(Component);

  function Component(element) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaultOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Component);

    _this = _super.call(this);
    _this.element = types.isString(element) ? _this.options.container.querySelector(element) : element; // An invalid selector or non-DOM node has been provided.

    if (!_this.element) {
      throw new Error("An invalid selector or non-DOM node has been provided for ".concat(_this.constructor.name, "."));
    }

    _this.element[_this.constructor.name] = _this.constructor._interface.bind(_assertThisInitialized(_this));
    _this.element[_this.constructor.name].Constructor = _this.constructor.name;
    _this.id = utils.uuid(_this.constructor.name + '-');
    _this.options = _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), options), dom.optionsFromDataset(_this.element, defaultOptions));
    return _this;
  }
  /**
   * Initiate all DOM element corresponding to selector
   * @method
   * @return {Array} Array of all Plugin instances
   */


  _createClass(Component, null, [{
    key: "attach",
    value: function attach() {
      var _this2 = this;

      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var defaultOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var instances = new Array();

      if (selector === null) {
        return instances;
      }

      options = _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), options), dom.optionsFromDataset(this.element, defaultOptions));
      var elements = dom.querySelectorAll(selector, options.container) || [];
      elements.forEach(function (element) {
        // Check if plugin has already been instantiated for element
        if (typeof element[_this2.constructor.name] === 'undefined') {
          // If no then instantiate it and register it in element
          instances.push(new _this2(element, _objectSpread({
            selector: selector
          }, options)));
        } else {
          // If Yes then return the existing instance
          instances.push(element[_this2.constructor.name]);
        }
      });
      return instances;
    }
  }, {
    key: "_interface",
    value: function _interface() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (typeof options === 'string') {
        if (typeof this[options] === 'undefined') {
          throw new TypeError("No method named \"".concat(options, "\""));
        }

        return this[options](options);
      }

      return this;
    }
  }]);

  return Component;
}(EventEmitter);

export { Component as default };